import React from 'react';

import OrderForm from '@/components/blocks/forms/order-form';
import { EditGuard } from '@/components/guards/permission-guards';
import { useGlobalState } from '@/contexts/GlobalStateContext';
import type { OrderUpdateSheetProps } from '@/types/module';
import { RESOURCES } from '@/utils/permissions';

const OrderUpdateSheet: React.FC<OrderUpdateSheetProps> = ({
  order,
  onOrderUpdated,
}) => {
  const { hideSheet } = useGlobalState();

  const handleSuccess = async () => {
    hideSheet('order-update');
    await onOrderUpdated?.();
  };

  const handleCancel = () => {
    hideSheet('order-update');
  };

  return (
    <EditGuard resource={RESOURCES.SALES_ORDERS}>
      <OrderForm
        mode='update'
        order={order}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </EditGuard>
  );
};

export default OrderUpdateSheet;
